module.exports = __webpack_public_path__ + "static/media/drawTool.c98dbd6b.gif";